import Util from "@/helper/Utility.js";
import ModalMaster from "@/components/Modal/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";

export default {
    components: {
        ModalMaster,
    },
    data: function () {
        return {
            modalFactory: new ModalFactory(),
            modalController: null,
        };
    },
    created: function () {
        this.initialGenericModal();
        this.inititalPdpaModal();

        if (Util.isFunction(this.onSetupModalCompleted)) {
            this.onSetupModalCompleted();
        }
    },
    methods: {
        initialGenericModal: function () {
            this.modalController = this.modalFactory.getModalController();
            this.alertModal = this.modalFactory.getAlertModal();
            this.alertDescription = this.modalFactory.getAlertDescriptionModal();
            this.alertPointModal = this.modalFactory.getAlertPointModal();
            this.confirmModal = this.modalFactory.getConfirmModal();
            this.loadingModal = this.modalFactory.getLoadingModal();
            this.passwordModal = this.modalFactory.getPasswordModal();
            this.loginModal = this.modalFactory.getLoginModal();
            this.successModal = this.modalFactory.getSuccessModal();
            this.alertTranfersPointModal = this.modalFactory.getAlertTransferPointModal();
            this.confirmTransferMAAIModal = this.modalFactory.getConfirmTransferMAAIModal();
            this.transferFailModal = this.modalFactory.getTransferFailModal();
            this.contractCallCenterModal = this.modalFactory.getContractCallCenterModal();
        },
        initialOtpModal: function () {
            this.otpModal = this.modalFactory.getOtpModal();
        },
        inititalPdpaModal: function () {
            this.pdpaModal = this.modalFactory.getPdpaModal();
            this.pdpaRegisterModal = this.modalFactory.getPdpaRegisterModal();
        },
        initialRedeemModal: function () {
            this.confirmRedeemModal = this.modalFactory.getConfirmRedeemModal();
            this.drawDeliveryModal = this.modalFactory.getDrawDeliveryModal();
            this.serialModal = this.modalFactory.getSerialModal();
            this.shippingAddressModal = this.modalFactory.getShippingAddressModal();
        },
        initialHistoryModal: function () {
            this.serialModal = this.modalFactory.getSerialModal();
        },
        initialAddressModal: function() {
            this.addAddressModal = this.modalFactory.getAddAddressModal();
            this.editAddressModal = this.modalFactory.getEditAddressModal();
            this.listAddressModal = this.modalFactory.getListAddressModal();
        },
        initialTaxAddressModal: function() {
            this.addTaxAddressModal = this.modalFactory.getAddTaxAddressModal();
            this.editTaxAddressModal = this.modalFactory.getEditTaxAddressModal();
            this.listTaxAddressModal = this.modalFactory.getListTaxAddressModal();
        },
    }
}
